import React from 'react'

export const utahSetupVars = {
  siteId: 'utah',
  pathPrefix: '/ut',
  menuHeader: "Discover Utah's Solution for:",
  appUrl: 'https://ut.headed2.com',
  logoImg: '/images/assets/utah/horizontal/dark.svg',
  headerTitle: `The Utah CareerExplorer is a system designed for Utah`
}
